import { HelpCircle } from 'lucide-react';
import openHelp from '../../utils/openHelp';

/**
 * WizardHeader - Progress indicator and step title display
 *
 * Features:
 * - Step counter (Step X of 4)
 * - Step title display
 * - Visual progress bar (0%, 25%, 50%, 75%, 100%)
 *
 * Design:
 * - Inter font, 18px H1 for title, 13px body for step counter
 * - Emerald-500 (#10B981) for progress bar
 * - Gray-200 (#E5E7EB) for background track
 */
const WizardHeader = ({ currentStep, stepTitle }) => {
  // Calculate progress percentage (0% → 25% → 50% → 75% → 100%)
  const progressPercentage = ((currentStep - 1) / 4) * 100;

  return (
    <div className="px-6 py-4 border-b border-gray-200 bg-white">
      {/* Step Counter + Help button */}
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm text-gray-600 font-inter">
          Schritt {currentStep} von 4
        </div>
        <button
          type="button"
          aria-label="Hilfe"
          onClick={() => openHelp('wizard')}
          className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <HelpCircle size={20} />
        </button>
      </div>

      {/* Step Title */}
      <h1 className="text-lg font-bold text-gray-900 mb-3 font-inter">
        {stepTitle}
      </h1>

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
        <div
          className="bg-emerald-500 h-full transition-all duration-300 ease-out"
          style={{ width: `${progressPercentage}%` }}
          role="progressbar"
          aria-valuenow={progressPercentage}
          aria-valuemin="0"
          aria-valuemax="100"
          aria-label={`Fortschritt: ${progressPercentage}% abgeschlossen`}
        />
      </div>
    </div>
  );
};

export default WizardHeader;
